import React, { useContext } from 'react'
import * as OC from '../data-comp'
import * as R from 'ramda'
import { BlockCustomerSvc as BlockCustomerAPI } from '../api/block_customer_api'
import { Order, OrderCtx } from '../model-order'

interface OrderInfoProps {
  presence: { user_id: number; user_name: string; order: string }[]
}
export default function OrderInfo(props: OrderInfoProps): JSX.Element {
  const data = useContext(OrderCtx) as Order

  const address = data.carts.settings.service.id === 'DELIVERY' ? data.carts.settings.service.address : null
  const email = data.carts.customer.email
  const phone = data.carts.customer.phone

  return (
    <div className="row">
      <div className="col-12">
        <OC.StateContainer>
          <div className="order-heading">
            <div className="col-sm-12 col-md-4">
              <p className="info info-id">
                <span key="id" className="info-label">
                  Id
                </span>
                <span key="val" className="info-value info-value-id">
                  <OC.ShortOrderUUID />
                </span>
              </p>
              <p className="info info-state">
                <span key="id" className="info-label">
                  State
                </span>
                <span key="val" className="info-value info-value-state">
                  <OC.State />
                </span>
              </p>
              <p className="info info-value-type">
                <span key="id" className="info-label">
                  <OC.Service.Label />
                </span>
                <span key="val" className="info-value info-value-type">
                  <OC.Totals.GrandTotal />
                </span>
              </p>
            </div>
            <BlockCustomerAPI>
              <div className="col-sm-12 col-md-4">
                <div className="info">
                  <span key="id" className="info-label">
                    Customer <OC.CustomerRegistered />
                  </span>
                  <div key="val" className="info-value">
                    <OC.CustomerName />
                    <br />
                    <OC.CustomerEmail />
                    <OC.BlockButton type="email" value={email} />
                    <br />
                    <OC.CustomerPhone />
                    <OC.BlockButton type="phone" value={phone} />
                  </div>
                </div>
                <OC.Service.IsDelivery>
                  <div className="info">
                    <span key="id" className="info-label">
                      Address
                    </span>
                    <span key="val" className="info-value">
                      <OC.Service.DeliveryAddress>
                        <OC.Address.Full />
                        {address && <OC.BlockButton type="address" address={address} />}
                      </OC.Service.DeliveryAddress>
                    </span>
                  </div>
                </OC.Service.IsDelivery>
              </div>
            </BlockCustomerAPI>

            <div className="col-sm-12 col-md-4">
              <p className="info">
                <span key="id" className="info-label">
                  <OC.RestaurantName />
                </span>
                <span key="val" className="info-value">
                  <OC.Service.RestaurantAddress>
                    <OC.Address.Full />
                  </OC.Service.RestaurantAddress>
                </span>
              </p>
              <OC.Service.IsDelivery>
                <p className="info">
                  <span className="info-label">Pickup</span>
                  <span className="info-value">
                    <OC.PickupTime />
                  </span>
                </p>
              </OC.Service.IsDelivery>
              <p className="info">
                <span className="info-label">Due</span>
                <span className="info-value">
                  <OC.OrderTime />
                </span>
              </p>
              <PresenceInfo presence={props.presence} />
            </div>
          </div>
        </OC.StateContainer>
      </div>
    </div>
  )
}

const getInitials = R.compose(
  R.join(''),
  R.map((str: string) => str.substring(0, 1)),
  R.split(/\s+/)
)

export function PresenceInfo(props: OrderInfoProps) {
  return (
    <span className="presence-info">
      {R.uniqBy(R.prop('user_id'), props.presence).map((p) => (
        <span key={p.user_id} className="label label-default presence-role-admin" title={p.user_name}>
          <a href={`https://users.zuppler.com/users/${p.user_id}`} target="_blank" rel="noreferrer">
            {getInitials(p.user_name || 'N A')}
          </a>
        </span>
      ))}
    </span>
  )
}
